import { Action } from "models/content/Comm";

export enum QuestionResponseType {
  Default = 0,
  OpenToAll = 1,
  RatherNotSay = 2,
  Nothing = 3
}

export class QuestionResponse {

  id: number;

 
  txtId: string;
  txt: string;
 
  score: number;

 
  questionId: number;

 
  groupTxtId: string;

 
  assetUrl: string;

 
  ordinal: number;

 
  isCore: boolean;

 
  additionalIds: string;

 
  preValidation: any;

 
  type: number;

 
  action: Action;

 
  column5: number;
}